var map = {
	"./gcode.tmLanguage.json": [
		"041f",
		"grammar-gcode-tmLanguage-json"
	],
	"./klipper-config.tmLanguage.json": [
		"7c9d",
		"grammar-klipper-config-tmLanguage-json"
	],
	"./log.tmLanguage.json": [
		"3d8e",
		"grammar-log-tmLanguage-json"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "f6e6";
module.exports = webpackAsyncContext;